var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.92485 5.62767L5.19911 0.0892115C5.17455 0.0629281 5.14402 0.0418191 5.10964 0.0273436C5.07525 0.0128681 5.03783 0.00537109 4.99995 0.00537109C4.96208 0.00537109 4.92465 0.0128681 4.89027 0.0273436C4.85588 0.0418191 4.82536 0.0629281 4.8008 0.0892115L0.0750588 5.62767C0.0455997 5.66159 0.0272725 5.70242 0.0221952 5.74543C0.0171179 5.78845 0.025498 5.83189 0.0463668 5.87075C0.0674013 5.90947 0.0998687 5.94209 0.140119 5.96491C0.18037 5.98774 0.226809 5.99989 0.274215 5.99998H9.72569C9.7731 5.99989 9.81954 5.98774 9.85979 5.96491C9.90004 5.94209 9.93251 5.90947 9.95354 5.87075C9.97441 5.83189 9.98279 5.78845 9.97771 5.74543C9.97264 5.70242 9.95431 5.66159 9.92485 5.62767Z",
    fill: "#8CC63F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGain);
export default __webpack_public_path__ + "static/media/gain.7235eab3fbf13696676cd11c30417f01.svg";
export { ForwardRef as ReactComponent };